// The verbatim-list inputs of an open-ended block, ported from the coffee block's
// calcVerbatimProps. The list draws the answers as they were written, so it needs little beyond
// the answer itself; the width it has to fit is the list's own to measure.
//
// `format` is the mounting view's own when it has one - the conversation block reads its verbatims
// through a format of its own - else the question's.

export const calcVerbatimProps = ({ answer, config, format, verbatimFormat } = {}) => ({
  format: verbatimFormat || format,
  answer,
  config
})
